import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import { withRouter, Route, Redirect } from 'react-router-dom';
import { Button, TabMenu, MenuItem } from '@smartplatform/ui';
import EditDiscussion from './EditDiscussion';
import Comments from './Comments';
import Poll from './Poll';

import store from '../../store';

@withRouter
@observer
export default class Edit extends React.Component {
	@observable tab;
	@observable record = null;

	constructor(props) {
		super(props);
		store.ui.setPage('discussion');
	}

	rootPath = `/admin/discussions`;

	init = async () => {
		store.ui.setPage('discussion');
	};

	menuItems = [
		{
			label: 'Обсуждение',
			id: 'discussion',
		},
		{
			label: 'Опрос',
			id: 'poll',
		},
		{
			label: 'Комментарии',
			id: 'comments',
		},
	];

	switchTab = tab => {
		this.tab = tab.id;
		const { id } = this.props.match.params;
		store.history.push(`${this.rootPath}/${id}/${tab.id}`);
		store.ui.setPage(tab.id);
	};

	render() {
		let { id } = this.props.match.params;
		id = isNaN(id) ? false : id;
		const rootPath = `/admin/discussions`;
		const path = `${rootPath}/${id}`;

		if (store.route.path === path && store.route.path !== `${rootPath}/create`) {
			return <Redirect to={`${path}/discussion`} />;
		}
		return (
			<div>
				<Button className="list-btn" label="К списку обсуждений" onClick={() => this.props.history.push(rootPath)} />
				<TabMenu>
					{this.menuItems.map(tab => (
						<MenuItem
							key={`category-${tab.id}`}
							label={tab.label}
							onClick={() => this.switchTab(tab)}
							active={store.ui.page === tab.id}
						/>
					))}
				</TabMenu>

				<Route exact path={`${rootPath}/create`} component={() => <EditDiscussion id={id} />} />
				<Route
					exact
					path={`${rootPath}/:id/discussion`}
					component={() => <EditDiscussion rootPath={rootPath} id={id} />}
				/>
				<Route exact path={`${rootPath}/:id/poll`} component={() => <Poll id={id} rootPath={rootPath} />} />
				<Route exact path={`${rootPath}/:id/comments`} component={() => <Comments id={id} rootPath={rootPath} />} />
			</div>
		);
	}
}
